<template>
  <div>
    <Nav></Nav>
    <b-container>

      <b-card class="mt-3">
        <b-row class="px-3" align-v="center">
          <b-col class="ml--2">
            <h1 class="mb-0">
              Sucursal: {{ this.actualSucursal.nombre }}
            </h1>
            <div v-if="this.actualSucursal.status">
              <span class="text-success">● </span>
              <small>Activa</small>
            </div>
            <div v-else>
              <span class="text-danger">● </span>
              <small>Inactiva</small>
            </div>
            <div class="mt-2">
              <b-badge :variant="lastSeenVariant" class="p-2">
                <i class="fas fa-clock mr-1"></i>
                Última conexión: {{ formatLastSeen(actualSucursal.last_seen) }}
                <span v-if="actualSucursal.last_seen"> ({{ formatLastSeenAbs(actualSucursal.last_seen) }})</span>
              </b-badge>
            </div>

          </b-col>
          <b-col md="auto">
            <base-button class="mx-3" @click="getSucursal" type="primary"
              size="sm"><b-icon-arrow-clockwise></b-icon-arrow-clockwise></base-button>
          </b-col>
        </b-row>
        <hr class="my-1" />
        <b-row>
          <b-col>
            <base-button type="primary" class="my-1" size="sm">Editar</base-button>
            <base-button  class="my-1" :disabled="!this.actualSucursal.status" @click="sendRemoteAction('updatePosVersion')" type="primary" size="sm">Actualizar version POS</base-button>
            <base-button  class="my-1" :disabled="!this.actualSucursal.status" @click="sendRemoteAction('updateInfo')" type="primary" size="sm">Actualizar Info POS</base-button>
            <base-button class="my-1" @click="$router.push('/sucursal/' + actualSucursal.id + '/online-rate')" type="info" size="sm">Tasa en línea por hora</base-button>
          </b-col>
        </b-row>
        <hr class="my-1" />
        <b-row>
          <b-col>
            <h3 style="text-align: center;"></h3>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" cols="12">
            <p>
              Version: {{ this.actualSucursal.version }}<br>
              Version de Base de datos: {{ this.actualSucursal.database_version }}<br>
              Estatus de migracion de base de datos: {{ (this.actualSucursal.database_dirty == 0 ? 'SALUDABLE' : 'NO SALUDABLE')
              }}<br>
              Ultima actualización: {{ this.actualSucursal.version_last_update }}
            </p>
          </b-col>
          <b-col md="6" cols="12">
            <p>
              ID Rappi: {{ this.actualSucursal.rappi_id }} <br>
              Menu Rappi: {{ this.actualSucursal.rappi_menu_id }}<br>
              ID Uber: {{ this.actualSucursal.uber_store_id }}<br>
              Menu Uber: {{ this.actualSucursal.uber_menu_id }}
            </p>
          </b-col>
        </b-row>
      </b-card>


      <b-card class="mt-3">
        <b-row class="px-3" align-v="center">
          <b-col class="ml--2">
            <h1 class="mb-0">Equipo POS (Servidor Local)</h1>
            <div v-if="device.active_device">
              <span class="text-success">● </span>
              <small>Registrado · {{ device.active_device.hostname || device.active_device.device_id }}</small>
            </div>
            <div v-else-if="device.needs_initial_device_claim">
              <span class="text-warning">● </span>
              <small>Sin registrar · ventana de migración legacy abierta</small>
            </div>
            <div v-else>
              <span class="text-warning">● </span>
              <small>Sin registrar · el técnico debe usar el código de provisión</small>
            </div>
          </b-col>
          <b-col md="auto">
            <base-button class="mx-3" @click="getDevice" type="primary" size="sm">
              <b-icon-arrow-clockwise></b-icon-arrow-clockwise>
            </base-button>
          </b-col>
        </b-row>
        <hr class="my-1" />
        <b-row>
          <b-col md="6">
            <h4>Código de provisión</h4>
            <p>
              <code style="font-size: 1.2rem; padding: 4px 8px; background: #f5f5f5; border-radius: 4px">
                {{ device.provisioning_code || '—' }}
              </code>
              <base-button v-if="device.provisioning_code" class="ml-2" size="sm" type="secondary"
                @click="copyCode">
                <b-icon-clipboard></b-icon-clipboard> Copiar
              </base-button>
            </p>
            <p class="text-muted small">
              Compártelo solo con el técnico que instalará el POS en esta sucursal.
            </p>
            <base-button type="warning" size="sm" @click="confirmRotateCode" :disabled="rotating">
              Rotar código
            </base-button>
          </b-col>
          <b-col md="6" v-if="device.active_device">
            <h4>Dispositivo activo</h4>
            <p>
              <strong>device_id:</strong> <code>{{ device.active_device.device_id }}</code><br>
              <strong>hostname:</strong> {{ device.active_device.hostname || '—' }}<br>
              <strong>registrado:</strong> {{ device.active_device.registered_at }}<br>
              <strong>última actividad:</strong> {{ device.active_device.last_seen_at || '—' }}<br>
              <strong>origen del registro:</strong>
              <b-badge :variant="device.active_device.claim_source === 'legacy_existing' ? 'secondary' : 'primary'">
                {{ device.active_device.claim_source }}
              </b-badge>
            </p>
            <base-button type="danger" size="sm" @click="confirmRelease" :disabled="releasing">
              Liberar dispositivo
            </base-button>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="mt-3" border-variant="warning">
        <b-row class="px-3" align-v="center">
          <b-col class="ml--2">
            <h1 class="mb-0">Conexión al POS (solo soporte)</h1>
            <b-alert show variant="warning" class="mt-2 mb-0">
              <strong>Uso exclusivo del equipo de soporte.</strong>
              Esta configuración apunta al túnel remoto y NO debe usarse en
              producción ni compartirse con operadores de sucursal. El POS de
              la sucursal debe seguir conectándose a su servidor local
              normal.
            </b-alert>
          </b-col>
        </b-row>
        <hr class="my-1" />
        <b-row>
          <b-col md="6">
            <h4>IP servidor</h4>
            <p>
              <code style="font-size: 1rem; padding: 4px 8px; background: #f5f5f5; border-radius: 4px">
                {{ posTunnelHost }}
              </code>
              <base-button class="ml-2" size="sm" type="secondary" @click="copyTunnelField">
                <b-icon-clipboard></b-icon-clipboard> Copiar
              </base-button>
            </p>
          </b-col>
          <b-col md="6">
            <h4>Parámetros frontpos</h4>
            <p>
              <strong>SSL:</strong> activado<br>
              <strong>Puerto wb:</strong> 443<br>
              <strong>Puerto ws:</strong> 443
            </p>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="mt-3" >
        <b-row class="px-3" align-v="center">
          <b-col class="ml--2">
            <h1 class="mb-0">
              Uber Eats
            </h1>
            <div v-if="this.actualSucursal.uber_store_id==null">
              <span class="text-warning">● </span>
              <small>No Configurado</small>
            </div>
            <div v-else-if="this.eatsStatus.status == 'ONLINE'">
              <span class="text-success">● </span>
              <small>Activa</small>
            </div>
            <div v-else-if="this.eatsStatus.status == 'OFFLINE'">
              <span class="text-danger">● </span>
              <small>INACTIVA Razon: {{ this.eatsStatus.offlineReason}} {{ this.eatsStatus.paused_until}}</small>
            </div>
            <div v-else-if="this.eatsStatus.status == ''">
              <span class="text-warning">● </span>
              <small>Sin Informacion</small>
            </div>
           
          </b-col>
          <b-col md="auto">
            <base-button v-if="this.actualSucursal.uber_store_id!=null" class="mx-3" @click="getUberInfo" type="primary"
              size="sm"><b-icon-arrow-clockwise></b-icon-arrow-clockwise></base-button>
          </b-col>
        </b-row>
        <hr class="my-1" />
        <div v-if="this.actualSucursal.uber_store_id!=null">
          <b-row v-if="this.hasPermission('rrn:central:platforms:uber')">
            <b-col>
              <base-button  class="my-1"  @click="sendUberMenu" type="primary" size="sm">Enviar Menu Uber</base-button>
            </b-col>
          </b-row>
          <hr class="my-1" />

          <b-row >
            <b-col>
              <b-alert :show="!this.uberInfo.pos_data.integration_enabled" variant="warning">La integración no se encuentra activa para esta tienda. Solicita a tu contacto de soporte que active esta tienda.</b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" cols="12">
              <p>
                Nombre: {{ this.uberInfo.name }}<br>
                ID de Tienda: {{ this.uberInfo.store_id }}<br>
                Direccion: {{ this.uberInfo.location.address }}<br>
                Tiempo Promedio Prep: {{ this.uberInfo.avg_prep_time }}<br>
                Status: {{ this.uberInfo.status }}<br>
                Status Integración: {{ this.uberInfo.pos_data.integration_enabled }}<br>
                Url web: <a :href="uberInfo.web_url">{{ this.uberInfo.web_url }}</a>
                
              </p>
              <h4>De la integracion</h4>
              <p>
                Auto Aceptacion: <b-icon v-if="this.uberIntegrationInfo.auto_accept_enabled" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon><br>
                Requiere Aceptacion Manual: <b-icon v-if="this.uberIntegrationInfo.require_manual_acceptance" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon><br>
                Integración habilitada: <b-icon v-if="this.uberIntegrationInfo.integration_enabled" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon><br>
                Status: {{ this.uberIntegrationInfo.online_status }}<br>
                Order Release Enabled: <b-icon v-if="this.uberIntegrationInfo.order_release_enabled" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon><br>
                Pos integration enabled: <b-icon v-if="this.uberIntegrationInfo.pos_integration_enabled" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon><br>
              </p>
            </b-col>
          </b-row>
        </div>
        
      </b-card>

      <b-card class="mt-3" >
        <b-row class="px-3" align-v="center">
          <b-col class="ml--2">
            <h1 class="mb-0">
              Configuraciones
            </h1>
          </b-col>
          <b-col md="auto">
            <base-button class="mx-3" @click="getRestaurantConfigs" type="primary" size="sm">
              <b-icon-arrow-clockwise></b-icon-arrow-clockwise>
            </base-button>
          </b-col>
        </b-row>
        <hr class="my-1" />
        <b-row>
          <b-col md="6" cols="12" v-for="(value, key) in cfgs" :key="key">
            <b-form-group>
              <template #label>
                <strong>{{ key }}</strong>
                <small class="text-muted ml-2">
                  sid: {{ value.sid || '—' }}
                </small>
              </template>
              <b-input-group>
                <b-form-input
                  v-model="cfgs[key].param1"
                  :placeholder="key"
                  :disabled="!cfgs[key].editing"
                  :readonly="!cfgs[key].editing"
                  size="sm"
                ></b-form-input>
                <b-input-group-append v-if="!cfgs[key].editing">
                  <base-button type="secondary" size="sm" @click="startEdit(key)">
                    Editar
                  </base-button>
                </b-input-group-append>
                <b-input-group-append v-else>
                  <base-button
                    type="primary"
                    size="sm"
                    :disabled="savingKey === key"
                    @click="saveConfig(key)"
                  >
                    <span v-if="savingKey === key">…</span>
                    <span v-else>Guardar</span>
                  </base-button>
                  <base-button
                    type="secondary"
                    size="sm"
                    :disabled="savingKey === key"
                    @click="cancelEdit(key)"
                  >
                    Cancelar
                  </base-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="mt-3">
        <b-row class="px-3" align-v="center">
          <b-col class="ml--2">
            <h1 class="mb-0">Propina obligatoria</h1>
            <small class="text-muted">
              Se calcula automáticamente en el POS y se exige al cobrar. El área
              sobrescribe a la sucursal.
            </small>
          </b-col>
          <b-col md="auto">
            <base-button class="mx-3" @click="getSettings" type="primary" size="sm">
              <b-icon-arrow-clockwise></b-icon-arrow-clockwise>
            </base-button>
          </b-col>
        </b-row>
        <hr class="my-1" />

        <!-- Nivel sucursal (branch) -->
        <b-row align-v="end">
          <b-col md="3" cols="12">
            <b-form-group label="Obligatoria (sucursal)">
              <b-form-checkbox v-model="tipBranch.mandatory" switch>
                {{ tipBranch.mandatory ? 'Sí' : 'No' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="3" cols="12">
            <b-form-group label="Modo">
              <b-form-select v-model="tipBranch.mode" :options="tipModeOptions" size="sm"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3" cols="12">
            <b-form-group :label="tipBranch.mode === 'percentage' ? 'Porcentaje (%)' : 'Monto fijo'">
              <b-form-input v-model.number="tipBranch.value" type="number" min="0" step="0.01" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3" cols="12">
            <b-form-group label=" ">
              <base-button type="primary" size="sm" :disabled="tipSavingScope === 0" @click="saveTip(0, tipBranch)">
                <span v-if="tipSavingScope === 0">…</span>
                <span v-else>Guardar</span>
              </base-button>
            </b-form-group>
          </b-col>
        </b-row>

        <hr class="my-1" />
        <h3 class="mb-2">Overrides por área</h3>

        <b-row v-for="ov in tipOverrides" :key="ov.scope_id" align-v="end">
          <b-col md="3" cols="12">
            <b-form-group label="Área">
              <b-form-input :value="ov.name" disabled size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2" cols="12">
            <b-form-group label="Obligatoria">
              <b-form-checkbox v-model="ov.mandatory" switch>{{ ov.mandatory ? 'Sí' : 'No' }}</b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="3" cols="12">
            <b-form-group label="Modo">
              <b-form-select v-model="ov.mode" :options="tipModeOptions" size="sm"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="2" cols="12">
            <b-form-group :label="ov.mode === 'percentage' ? '%' : 'Monto'">
              <b-form-input v-model.number="ov.value" type="number" min="0" step="0.01" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2" cols="12">
            <b-form-group label=" ">
              <base-button type="primary" size="sm" :disabled="tipSavingScope === ov.scope_id" @click="saveTip(ov.scope_id, ov)">
                <span v-if="tipSavingScope === ov.scope_id">…</span>
                <span v-else>Guardar</span>
              </base-button>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row align-v="end">
          <b-col md="4" cols="12">
            <b-form-group label="Agregar override de área">
              <b-form-select v-model="tipNewArea" :options="tipAreaOptions" size="sm"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="auto">
            <b-form-group label=" ">
              <base-button type="secondary" size="sm" :disabled="!tipNewArea" @click="addTipOverride">Agregar</base-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
import _ from 'lodash';
import moment from 'moment';

export default {
  name: "Sucursal",
  components: { Nav },
  data() {
    return {
      configs:[],
      savingKey: null,
      editSnapshots: {},
      // Propina obligatoria (framework settings: scope branch/area)
      tipBranch: { mandatory: false, mode: 'percentage', value: 0 },
      tipOverrides: [],   // [{ scope_id, name, mandatory, mode, value }]
      tipAreas: [],       // [{ id, name }]
      tipNewArea: null,
      tipSavingScope: null,
      cfgs:{
        companyName:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        razonSocial:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        regimenFiscal:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        rfc:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        direccionMatriz1:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        direccionMatriz2:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        direccionMatriz3:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        sucursalName:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        direccionSucursal1:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        direccionSucursal2:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        direccionSucursal3:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        maxCashPaydesk:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        maxOpenShift:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        minOpenShift:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        ticketLastLine:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        facturacionLink:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
        ticketExtraQr:{sid:0,param1:"",param2:"",param3:"",param4:"",editing:false},
      },

      actualSucursal: {
        id: 0,
        description: "",
        code: "",
        name: "",
        unit: "",
        base_portion: 1
      },
      device: {
        sucursal_id: 0,
        provisioning_code: "",
        needs_initial_device_claim: false,
        active_device: null,
      },
      releasing: false,
      rotating: false,
      eatsStatus: {
        status: "",
        offlineReason: ""
      },

      uberIntegrationInfo:{
        store_id: "",
        pos_integration_enabled: false,
        online_status: "",
        partner_store_id: "",
        order_release_enabled: false,
        auto_accept_enabled: false,
        order_manager_client_id: "",
        integration_enabled: false
      },
      uberInfo: {
        name: "",
        store_id: "",
        location: {
          address: "",
          address_2: "",
          city: "",
          country: "",
          postal_code: "",
          state: "",
          latitude: 0,
          longitude: 0
        },
        contact_emails: [
        ],
        raw_hero_url: "",
        price_bucket: "",
        avg_prep_time: 0,
        status: "",
        partner_store_id: "",
        timezone: "",
        pos_data: {
          integration_enabled: false,
          order_manager_client_id: ""
        },
        merchant_store_id: "",
        web_url: ""
      }
    };
  },
  beforeRouteUpdate(to, from) {
    console.log(to);
    console.log(from);
    this.initData();
  },
  mounted() {
    this.initData();
  },
  computed: {
    tipModeOptions() {
      return [
        { value: 'percentage', text: 'Porcentaje (%)' },
        { value: 'fixed', text: 'Monto fijo' },
      ];
    },
    // Áreas aún sin override (para el selector de "agregar override")
    tipAreaOptions() {
      let self = this;
      let opts = this.tipAreas
        .filter(function (a) {
          return !self.tipOverrides.find(function (o) { return o.scope_id === a.id; });
        })
        .map(function (a) { return { value: a.id, text: a.name }; });
      return [{ value: null, text: 'Selecciona área...' }].concat(opts);
    },
    // Tunnel hostname matches the embedded frpc subdomain in
    // localback/app/modules/frpc/frpc.go: "{tenant}-{sucursal_id}".
    posTunnelHost() {
      const tenant = this.$store.getters["server/tenant"] || "tizon";
      const id = this.actualSucursal.id || 0;
      if (!id) return "";
      return `${tenant}-${id}.local.rigadapos.com`;
    },
    lastSeenVariant() {
      const m = this.parseLastSeen(this.actualSucursal.last_seen);
      if (!m) return "secondary";
      // Green if seen within 5 min, yellow within 1h, red otherwise.
      const mins = moment().diff(m, "minutes");
      if (mins <= 5) return "success";
      if (mins <= 60) return "warning";
      return "danger";
    },
  },
  methods: {
    parseLastSeen(value) {
      if (!value) return null;
      // Backend stores last_seen with NOW(3) in UTC and the string carries no zone,
      // so parse it as UTC; display helpers convert to the viewer's local time.
      const m = moment.utc(value, ["YYYY-MM-DD HH:mm:ss.SSS", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601], true);
      return m.isValid() ? m : null;
    },
    formatLastSeen(value) {
      const m = this.parseLastSeen(value);
      return m ? m.locale("es").fromNow() : "Nunca";
    },
    formatLastSeenAbs(value) {
      const m = this.parseLastSeen(value);
      return m ? m.local().format("DD/MM/YYYY HH:mm:ss") : "Sin registro";
    },
    initData() {
      console.log("creando");
      console.log(this.$route.params.id);
      if (this.$route.params.id > 0) {
        console.log("producto no nuevo");
        this.actualSucursal.id = this.$route.params.id;
        this.getSucursal();
      }
      console.log("termina creacion");
      this.getRestaurantConfigs()
      this.getTipAreas()
    },
    // ---- Propina obligatoria (settings) ----
    getTipAreas(){
      let that=this
      axios.get("/restaurant/areas")
      .then(function(r){ that.tipAreas = r.data || []; that.getSettings() })
      .catch(function(e){ console.error(e); that.getSettings() })
    },
    areaName(id){
      let a = this.tipAreas.find(function(x){ return x.id === id })
      return a ? a.name : ('Área ' + id)
    },
    applyTipGroup(target, rows, scope, scopeId){
      rows.forEach(function(r){
        if(r.scope !== scope || r.scope_id !== scopeId) return
        if(r.setting_key === 'TIP_MANDATORY') target.mandatory = (r.setting_value === 'true' || r.setting_value === '1')
        if(r.setting_key === 'TIP_MODE') target.mode = r.setting_value || 'percentage'
        if(r.setting_key === 'TIP_VALUE') target.value = parseFloat(r.setting_value) || 0
      })
    },
    getSettings(){
      let that=this
      axios.get("/restaurant/"+this.actualSucursal.id+"/settings")
      .then(function(res){
        let rows = res.data || []
        // Nivel sucursal
        let branch = { mandatory:false, mode:'percentage', value:0 }
        that.applyTipGroup(branch, rows, 'branch', 0)
        that.tipBranch = branch
        // Overrides por área
        let areaIds = []
        rows.forEach(function(r){
          if(r.scope === 'area' && areaIds.indexOf(r.scope_id) === -1) areaIds.push(r.scope_id)
        })
        that.tipOverrides = areaIds.map(function(aid){
          let o = { scope_id: aid, name: that.areaName(aid), mandatory:false, mode:'percentage', value:0 }
          that.applyTipGroup(o, rows, 'area', aid)
          return o
        })
      }).catch(function(e){ console.error(e) })
    },
    addTipOverride(){
      if(!this.tipNewArea) return
      if(this.tipOverrides.find(o=>o.scope_id === this.tipNewArea)) return
      this.tipOverrides.push({
        scope_id: this.tipNewArea,
        name: this.areaName(this.tipNewArea),
        mandatory: this.tipBranch.mandatory,
        mode: this.tipBranch.mode,
        value: this.tipBranch.value,
      })
      this.tipNewArea = null
    },
    async saveTip(scopeId, data){
      let scope = scopeId === 0 ? 'branch' : 'area'
      this.tipSavingScope = scopeId
      let rid = parseInt(this.actualSucursal.id)
      let base = { scope: scope, scope_id: scopeId, restaurant_id: rid }
      let puts = [
        Object.assign({}, base, { setting_key:'TIP_MANDATORY', setting_value: data.mandatory ? 'true' : 'false', value_type:'bool' }),
        Object.assign({}, base, { setting_key:'TIP_MODE', setting_value: data.mode, value_type:'string' }),
        Object.assign({}, base, { setting_key:'TIP_VALUE', setting_value: String(data.value || 0), value_type:'float' }),
      ]
      try {
        let that=this
        await Promise.all(puts.map(function(p){ return axios.put("/restaurant/"+that.actualSucursal.id+"/settings", p) }))
        this.makeToast("Guardado", "Propina " + (scope === 'branch' ? 'sucursal' : this.areaName(scopeId)) + " actualizada", "success")
      } catch(err){
        this.makeToast("Error", err.request ? err.request.response : err.message, "danger")
      } finally {
        this.tipSavingScope = null
      }
    },
    getRestaurantConfigs(){
      let that=this
      axios.get("/restaurant/"+this.actualSucursal.id+"/config")
      .then(function(res){
        that.configs=res.data
        _.forOwn(that.cfgs, function(value, key) {
          let found=_.find(that.configs,function(n){
            return n.id==key
          })
          if(found!=undefined){
            that.cfgs[key].sid=found.sid
            that.cfgs[key].param1=found.param1
            that.cfgs[key].param2=found.param2
            that.cfgs[key].param3=found.param3
            that.cfgs[key].param4=found.param4
          }
        } );
      }).catch(function(e){
        console.error(e)
      })
    },
    startEdit(key){
      this.editSnapshots[key]={
        param1: this.cfgs[key].param1,
        param2: this.cfgs[key].param2,
        param3: this.cfgs[key].param3,
        param4: this.cfgs[key].param4,
      }
      this.cfgs[key].editing=true
    },
    cancelEdit(key){
      let snap=this.editSnapshots[key]
      if(snap){
        this.cfgs[key].param1=snap.param1
        this.cfgs[key].param2=snap.param2
        this.cfgs[key].param3=snap.param3
        this.cfgs[key].param4=snap.param4
        delete this.editSnapshots[key]
      }
      this.cfgs[key].editing=false
    },
    async saveConfig(key){
      let cfg=this.cfgs[key]
      let payload={
        sid: cfg.sid || 0,
        id: key,
        param1: cfg.param1,
        param2: cfg.param2,
        param3: cfg.param3,
        param4: cfg.param4,
        restaurant_id: parseInt(this.actualSucursal.id),
      }
      this.savingKey=key
      try {
        let res=await axios.put("/restaurant/"+this.actualSucursal.id+"/config/"+encodeURIComponent(key), payload)
        if(res.data && res.data.sid){
          this.cfgs[key].sid=res.data.sid
        }
        this.cfgs[key].editing=false
        delete this.editSnapshots[key]
        this.makeToast("Guardado", key+" actualizado", "success")
      } catch(err) {
        this.makeToast("Error", err.request ? err.request.response : err.message, "danger")
      } finally {
        this.savingKey=null
      }
    },
    getUberInfo() {
      let that = this;
      axios
        .get("/uber/store/" + this.actualSucursal.uber_store_id+"/status")
        .then(function (response) {
          that.eatsStatus = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
        axios
        .get("/uber/store/" + this.actualSucursal.uber_store_id+"/info")
        .then(function (response) {
          that.uberInfo = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
        axios
        .get("/uber/store/" + this.actualSucursal.uber_store_id+"/integration/status")
        .then(function (response) {
          console.log("getuberposinfo")
          console.log(response.data)
          that.uberIntegrationInfo = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },

    getSucursal() {
      let that = this;
      axios
        .get("/sucursal/" + this.actualSucursal.id)
        .then(function (response) {
          that.actualSucursal = response.data;
          if (that.actualSucursal.uber_store_id!=null){
            that.getUberInfo()
          }
          that.getDevice();
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getDevice() {
      let that = this;
      axios
        .get("/sucursal/" + this.actualSucursal.id + "/device")
        .then(function (response) {
          that.device = response.data;
        })
        .catch(function (err) {
          // 404 just means no row exists yet; not an error worth toasting.
          if (err.response && err.response.status !== 404) {
            that.makeToast("Error", err.request.response, "danger");
          }
        });
    },
    copyCode() {
      if (!this.device.provisioning_code) return;
      navigator.clipboard.writeText(this.device.provisioning_code).then(
        () => this.makeToast("Copiado", "Código copiado al portapapeles", "success"),
        () => this.makeToast("Error", "No se pudo copiar al portapapeles", "danger"),
      );
    },
    copyTunnelField() {
      const value = this.posTunnelHost;
      if (!value) return;
      navigator.clipboard.writeText(value).then(
        () => this.makeToast("Copiado", value, "success"),
        () => this.makeToast("Error", "No se pudo copiar al portapapeles", "danger"),
      );
    },
    confirmRotateCode() {
      this.$bvModal
        .msgBoxConfirm(
          "Esto generará un código nuevo. El dispositivo registrado actualmente NO se desconecta (sigue funcionando con su device_secret). El código anterior dejará de ser válido para futuras claims. ¿Continuar?",
          {
            title: "Rotar código de provisión",
            okVariant: "warning",
            okTitle: "Rotar código",
            cancelTitle: "Cancelar",
            centered: true,
          }
        )
        .then((ok) => {
          if (ok) this.rotateCode();
        });
    },
    rotateCode() {
      this.rotating = true;
      let that = this;
      axios
        .post("/sucursal/" + this.actualSucursal.id + "/device/rotate-code")
        .then(function (response) {
          that.device.provisioning_code = response.data.provisioning_code;
          that.makeToast("Código rotado", "Nuevo código: " + response.data.provisioning_code, "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        })
        .finally(() => {
          that.rotating = false;
        });
    },
    confirmRelease() {
      this.$bvModal
        .msgBoxConfirm(
          "Esto desconectará al equipo POS de esta sucursal. Las sesiones activas se invalidan inmediatamente. El siguiente equipo que se instale deberá usar el código de provisión (la ventana legacy NO se reabre). ¿Continuar?",
          {
            title: "Liberar dispositivo",
            okVariant: "danger",
            okTitle: "Liberar",
            cancelTitle: "Cancelar",
            centered: true,
          }
        )
        .then((ok) => {
          if (ok) this.releaseDevice();
        });
    },
    releaseDevice() {
      this.releasing = true;
      let that = this;
      axios
        .delete("/sucursal/" + this.actualSucursal.id + "/device")
        .then(function () {
          that.makeToast("Liberado", "El dispositivo fue liberado", "success");
          that.getDevice();
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        })
        .finally(() => {
          that.releasing = false;
        });
    },
    updateProduct() {
      let that = this;
      if (this.actualSucursal.id > 0) {
        axios
          .put("/supply/" + this.actualSucursal.id, this.actualSucursal)
          .then(function (response) {
            that.actualSucursal = response.data;
            that.makeToast("Exito", "exito al guardar", "success");
            that.getSucursal();
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      } else {
        axios
          .post("/supply", this.actualSucursal)
          .then(function (response) {
            that.makeToast("Exito", "exito al crear, redirigiendo", "success");
            console.log(response.data);
            that.$router.push({
              name: "Sucursal",
              params: { id: response.data.id },
            });
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      }
    },
    sendUberMenu() {
      let that = this
      axios
        .put("/sucursal/" + this.actualSucursal.id + "/uber/uploadmenu", null)
        .then(function () {
          that.makeToast("Exito", "EXITO AL SUBIR EL MENU", "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });

    },

    sendRemoteAction(actiontype) {
      let that = this
      axios
        .get("/sucursal/" + this.actualSucursal.id + "/action/" + actiontype)
        .then(function () {
          that.makeToast("Exito", "EXITO AL enviar la accion", "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
 
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
